import { Button, ButtonProps, CircularProgress } from '@material-ui/core'

type PrimaryButtonProps = {
  outlined?: boolean
  buttonText?: string
  minWidth?: string
  isLoading?: boolean
}

const defaultProps = {
  outlined: false,
  buttonText: '',
  minWidth: '128px',
}

export const PrimaryButton = ({
  size,
  disabled,
  outlined,
  buttonText,
  minWidth,
  isLoading,
  ...props
}: PrimaryButtonProps & ButtonProps & typeof defaultProps) => {
  const buttonSize = size ?? 'large'

  return (
    <Button
      disabled={disabled || isLoading}
      disableElevation
      variant={outlined ? 'outlined' : 'contained'}
      size={buttonSize}
      className={`${buttonSize === 'large' ? 'px-6 h-14 ' : ' '} text-lg font-medium normal-case`}
      style={{
        minWidth: minWidth,
        border: outlined ? '2px solid' : '',
        borderColor: outlined ? '#00893F' : '',
        backgroundColor: outlined ? 'white' : '#00893F',
        color: outlined ? '#00893F' : 'white',
        opacity: disabled || isLoading ? '0.5' : '1',
      }}
      {...props}
    >
      {
        <div className="relative">
          {buttonText}
          {isLoading && (
            <div className="absolute w-full h-full -top-1.5">
              <CircularProgress color="inherit" />
            </div>
          )}
        </div>
      }
    </Button>
  )
}

PrimaryButton.defaultProps = defaultProps
